/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserQueryResponse {
    getFixupPrototypeFunction() { return UserQueryResponse.fixupPrototype; }

    static newInstance(model: Partial<UserQueryResponse>): UserQueryResponse {
        let obj = Object.assign(new UserQueryResponse(), model);
        UserQueryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserQueryResponse>): UserQueryResponse {
        if (!model) return null;
        return UserQueryResponse.newInstance(<UserQueryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserQueryResponse) {
        if (!obj) return;

        models.UserQueryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserQueryResponse): boolean {
        Object.setPrototypeOf(obj, UserQueryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.conversation_details) {
            models.ConversationDetails.fixupPrototype(this.conversation_details);
        }
    }

    /**
     * Conversation details
     */
    conversation_details: models.ConversationDetails;

    /**
     * List of suggested prompt based on the query
     */
    suggested_prompts: Array<string>;

}
